import IconButton from '@/components/Buttons/IconButton';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Heart from '@/images/Heart.svg';
import HeartFilled from '@/images/HeartFilled.svg';
import { useAddAvatarToFavourites } from '@/pages/avatar';
import { useAuth } from '@/services/auth';
import theme from '@/theme';
import styled from '@emotion/styled';
import CircularProgress from '@mui/material/CircularProgress';

const StyledIconButton = styled(IconButton)<{ active?: boolean }>`
    background: ${({ theme }) => theme.colors.white};
    color: ${theme.colors.secondary[900]} !important;
    border: ${({ theme }) => `1px solid ${theme.colors.black[300]}`};
    border-radius: 8px;
    padding: 7px;

    ${({ active }) => active && `color: ${theme.colors.primary[900]} !important;`}

    :hover {
        border-radius: 8px;
        background: ${({ theme }) => theme.colors.black[200]};
    }

    &.MuiButtonBase-root.Mui-disabled.MuiIconButton-root {
        background: ${({ theme }) => theme.colors.white};
        pointer-events: all;
    }
`;

interface Props {
    avatarId: string;
    className?: string;
    testId?: string;
}

export const AvatarFavouriteButton = ({ avatarId, className, testId }: Props) => {
    const { isAnonymous } = useAuth();
    const { isMutating, isLoading, isFavourite, toggle } = useAddAvatarToFavourites(avatarId);

    if (isAnonymous) {
        return null;
    }

    return (
        <StyledIconButton
            testId={testId}
            className={className}
            ariaLabel="favourite"
            active={isFavourite}
            onClick={toggle}
            disabled={isLoading || isMutating}>
            {isLoading ? <CircularProgress size={18} /> : <MaskedIcon src={isFavourite ? HeartFilled : Heart} size="18px" />}
        </StyledIconButton>
    );
};
